const RECAPTCHA_ERROR_CODES = [50020, 50021, 50022];

export const isRecaptchaError = (code) => RECAPTCHA_ERROR_CODES.includes(code);